import produce from 'immer'
import Actions from '../actions'
import {
  calculateTotalPrice,
  isRenewingEnrollment,
  getEarliestEnrollmentYear
} from '../utils/paymentUtils'
import moment from 'moment'
import {
  serializeMySubscriptions,
  serializeFutureSubscriptions,
  serializePlanDetails
} from '../utils/serializerUtil'

const initialZuoraSignatureDetails = {
  pageId: '',
  signature: '',
  token: '',
  tenantId: '',
  key: '',
  uri: '',
  price: 0,
  no_of_billing_period: null,
  billing_period: null
}
const initialState = {
  selectedPlan: null,
  selectedParentPlan: null,
  pendingSlot: null,
  subscriptions: null,
  my_subscriptions: null,
  future_subscriptions: null,
  credits: null,
  coupons: null,
  plans: null,
  subscriptionsLoading: false,
  timeLeft: null,
  timeLeftInDays: null,
  timeLeftInHours: null,
  isTimerVisible: true,
  isFloatingTimerVisible: false,
  last4: null,
  savedSlotExpiration: null,
  stripePublicKey: null,
  checkoutSessionId: null,
  billingPortalUri: null,
  activeHoliday: null,
  isLoadingCheckoutPage: false,
  walnutAppToken: null,
  walnutData: {},
  walnutUrl: 'https://sandbox-app.hellowalnut.com',
  isLoggedOut: true,
  couponData: [],
  isApplyCouponCodeLoading: false,
  isCouponSkipStripeAddressUpdateLoading: false,
  isCouponSkipStripeAddressUpdateErrorMessage: null,
  checkoutErrorMessage: null,
  skipCheckoutPage: false,
  zuoraSignatureDetails: initialZuoraSignatureDetails,
  isPlanLoading: false,
  isMedicareDialogOpen: false,
  phoneIsValid: false,
  phoneCodeSent: false,
  phoneIsInvalid: false,
  ppfPhoneNumberErrorMessage: '',
  emailExistsModalPPF: false,
  newPPFUser: false,
  paymentAddressObj: {},
  customerCoupon: null,
  zouraProcessFailDialog: false,
  zouraPageLoader: false,
  isCouponDialogVisible: false,
  couponError: null,
  invalidCouponErrorMessage: '',
  paymentDetailsData: null,
  updatingBillingDialogLoader: false,
  shouldShowNoSubscriptionsModal: false,
  isPPFUserAlreadyExist: false,
  isUserHaveSubscription: false,
  isPaymentFromPPF: false,
  ppfUserInfo: null,
  isNoServiceDialogVisible: false,
  isSlotExpireDialogVisible: false,
  isSomethingWentWrongDialogVisible: false,
  shouldDisplaySuccessDialog: false,
  shouldSkipLocationVerification: false,
  isDeclareLocationDialogVisible: false,
  isOnPaymentPlansPage: false,
  isApprovePaymentPopUpVisible: false,
  isPaymentDetailsLoading: false,
  isPaymentDetailsFailed: false,
  loadingInvoiceId: null,
  unauthenticatedPaymentDetails: null,
  isAutoPayDialogVisible: false,
  isAutoPaySetLoading: false,
  deepLinkRedirectAfterSuccess: null,
  includeDueInvoices: true,
  balancePerSubscription: [],
  paymentConfigPerSubscriptions: {},
  totalPaymentPrice: 0,
  enrollmentYears: [],
  isRenewingEnrollment: false,
  selectedEnrollmentYear: null
}

export default produce((draft, action) => {
  const { payload } = action

  switch (action.type) {
    case Actions.CHECKOUT_SESSION_WITHOUT_PAYMENT_REQUESTED:
    case Actions.CHECKOUT_SESSION_NO_MEMBER_REQUESTED_PPF: {
      draft.isLoadingCheckoutPage = true
      break
    }
    case Actions.NEW_USER_PPF_TOGGLE_MODAL: {
      draft.newPPFUser = true
      break
    }
    case Actions.CLOSE_NEW_USER_PPF_TOGGLE_MODAL: {
      draft.newPPFUser = false
      break
    }
    case Actions.PAYMENT_PLAN_REQUESTED: {
      draft.isPlanLoading = true
      break
    }
    case Actions.CHECK_PPF_PLAN_EMAIL_AND_PHONE_REQUESTED: {
      draft.isLoadingCheckoutPage = true
      break
    }
    case Actions.CHECK_PPF_PLAN_EMAIL_AND_PHONE_FAILED: {
      draft.isLoadingCheckoutPage = false
      draft.emailExistsModalPPF = true
      break
    }
    case Actions.CLOSE_EMAIL_EXIST_MODAL: {
      draft.emailExistsModalPPF = false
      break
    }
    case Actions.PPF_PLAN_PHONE_REQUESTED: {
      draft.isLoadingCheckoutPage = true
      break
    }
    case Actions.CHECK_PPF_PLAN_EMAIL_AND_PHONE_RECEIVED: {
      draft.isLoadingCheckoutPage = false
      draft.phoneIsInvalid = false
      break
    }
    case Actions.LOGIN_PHONE_NUMBER_RECEIVED:
    case Actions.PPF_PLAN_PHONE_RECEIVED: {
      draft.phoneCodeSent = true
      draft.isLoadingCheckoutPage = false
      break
    }
    case Actions.PPF_PLAN_PHONE_RECEIVED_FAIL: {
      draft.ppfPhoneNumberErrorMessage = payload.error.body.message
      draft.isLoadingCheckoutPage = false
      break
    }
    case Actions.CHECK_EXISTING_PPF_USER_SUBSCRIPTIONS_REQUESTED: {
      draft.isLoadingCheckoutPage = true
      break
    }
    case Actions.LOGIN_PHONE_NUMBER_REQUESTED: {
      const { isExistingUser, isComingFromPPFFlow } = payload

      if (isComingFromPPFFlow && isExistingUser) {
        draft.isPPFUserAlreadyExist = true
      }
      draft.isLoadingCheckoutPage = true
      break
    }

    case Actions.CHECK_EXISTING_PPF_USER_SUBSCRIPTIONS_RECIEVED: {
      const { plan_exists } = payload
      draft.isUserHaveSubscription = plan_exists
      draft.isLoadingCheckoutPage = false
      break
    }
    case Actions.CHECK_EXISTING_PPF_USER_SUBSCRIPTIONS_FAILED:
    case Actions.OPERATION_FAILED: {
      draft.isLoadingCheckoutPage = false
      break
    }
    case Actions.PPF_PLAN_PHONE_VERIFY: {
      draft.isLoadingCheckoutPage = true
      break
    }
    case Actions.PPF_PLAN_PHONE_ISVALID: {
      draft.phoneIsValid = true
      draft.isLoadingCheckoutPage = false
      break
    }
    case Actions.PPF_PLAN_PHONE_ISINVALID: {
      draft.phoneIsInvalid = true
      draft.isLoadingCheckoutPage = false
      break
    }
    case Actions.REQUEST_MEDICARE_DIALOG: {
      draft.isMedicareDialogOpen = true
      break
    }
    case Actions.REQUEST_CLOSE_MEDICARE_DIALOG: {
      draft.isMedicareDialogOpen = false
      break
    }

    case Actions.PAYMENT_PLAN_SELECTED: {
      draft.selectedPlan = serializePlanDetails([payload.selectedPlan])
      draft.customerCoupon = payload.customerCoupon
      draft.selectedParentPlan = payload.selectedPlan
      draft.isPlanLoading = false
      break
    }

    case Actions.PAYMENT_PLAN_SELECTED_FROM_PLANS: {
      draft.selectedPlan = payload.selectedPlan
      draft.customerCoupon = payload.customerCoupon
      draft.selectedParentPlan = payload.selectedPlan
      draft.isPlanLoading = false
      break
    }

    case Actions.PAYMENT_PLAN_UPDATED: {
      draft.selectedPlan = {
        ...payload.selectedPlan,
        isGift: !!payload?.isGift,
        isPayNow: !!payload?.isPayNow
      }
      break
    }
    case Actions.HOLDAY_IS_HERE_BABY: {
      draft.activeHoliday = payload

      break
    }
    case Actions.PROCEED_TO_CHECKOUT_PRESSED: {
      draft.isLoadingCheckoutPage = true

      break
    }
    case Actions.CHECKOUT_SESSION_WITHOUT_PAYMENT_FAILURE:
    case Actions.PROCEED_TO_CHECKOUT_PRESSED_CANCELLED: {
      draft.isLoadingCheckoutPage = false
      break
    }
    case Actions.CHECKOUT_WALNUT_RECEIVED: {
      const { token, data, walnut_url } = payload.payload
      draft.walnutAppToken = token
      draft.walnutData = data
      draft.walnutUrl = walnut_url
      draft.isLoadingCheckoutPage = false

      break
    }
    case Actions.CHECKOUT_SESSION_RECEIVED: {
      const { checkoutSessionId, stripePublicKey } = payload.payload

      draft.checkoutSessionId = checkoutSessionId
      draft.stripePublicKey = stripePublicKey
      draft.isLoadingCheckoutPage = false

      break
    }

    case Actions.COUPON_REDEEMED: {
      draft.coupons = -1

      break
    }
    case Actions.CREDIT_REDEEMED: {
      draft.credits = -1

      break
    }
    case Actions.PAYMENT_SUCCESS: {
      draft.savedSlotExpiration = null
      draft.timeLeft = null
      draft.timeLeftInDays = null
      draft.timeLeftInHours = null
      draft.skipCheckoutPage = false
      draft.couponData = []

      break
    }
    case Actions.DISPLAY_AUTO_PAY_POPUP: {
      draft.isAutoPayDialogVisible = true
      break
    }
    case Actions.CLOSE_AUTO_PAY_POPUP: {
      draft.isAutoPayDialogVisible = false
      break
    }
    case Actions.SET_AUTO_PAY_REQUESTED: {
      draft.isAutoPaySetLoading = true
      break
    }
    case Actions.SET_AUTO_PAY_FAILED:
    case Actions.SET_AUTO_PAY_RECEIVED: {
      draft.isAutoPaySetLoading = false
      break
    }
    case Actions.SLOT_SAVED_TICK: {
      if (draft.savedSlotExpiration) {
        const now = moment()
        draft.timeLeft = draft.savedSlotExpiration.diff(now, 'seconds')
        draft.timeLeftInHours = draft.savedSlotExpiration.diff(now, 'hours')
        draft.timeLeftInDays = draft.savedSlotExpiration.diff(now, 'days')
      }

      break
    }
    case Actions.SUBSCRIPTION_PLANS_REQUESTED: {
      draft.subscriptionsLoading = true
      break
    }
    case Actions.SUBSCRIPTION_PLANS_RECEIVED: {
      const { plans } = payload
      draft.plans = plans
      draft.subscriptionsLoading = false
      break
    }
    case Actions.SUBSCRIPTION_PLANS_ZOURA_RECEIVED: {
      const { plans } = payload
      draft.plans = serializePlanDetails(plans)
      draft.subscriptionsLoading = false

      break
    }

    case Actions.USER_PROFILE_RECEIVED: {
      const { payments } = { ...payload.profile }
      const {
        my_subscriptions,
        credits,
        coupons,
        last4,
        future_subscriptions,
        enrollment_years
      } = payments
      draft.my_subscriptions = serializeMySubscriptions(my_subscriptions)
      draft.future_subscriptions =
        serializeFutureSubscriptions(future_subscriptions)

      draft.enrollmentYears = enrollment_years

      draft.isRenewingEnrollment = isRenewingEnrollment(draft.enrollmentYears)
      draft.selectedEnrollmentYear = getEarliestEnrollmentYear(
        draft.enrollmentYears
      )

      draft.credits = credits
      draft.coupons = coupons
      draft.last4 = last4

      break
    }
    case Actions.SHOW_SLOT_TIMER: {
      draft.isTimerVisible = true

      break
    }
    case Actions.HIDE_SLOT_TIMER: {
      draft.isTimerVisible = false

      break
    }
    case Actions.CUSTOMER_INSERTED_COUPON: {
      const { customerCoupon } = payload
      draft.customerCoupon = customerCoupon

      break
    }
    case Actions.BILLING_PORTAL_RECEIVED: {
      const { billingPortalUri } = payload
      draft.billingPortalUri = billingPortalUri

      break
    }
    case Actions.COPAY_PLAN_DETAILS_RECEIVED: {
      const { selectedPlan } = payload
      draft.selectedPlan = serializePlanDetails([selectedPlan])?.[0]
      break
    }
    case Actions.GENERATE_PAYMENT_PAGE_DATA_REQUESTED: {
      draft.zuoraSignatureDetails = initialZuoraSignatureDetails
      draft.isLoadingCheckoutPage = true
      break
    }
    case Actions.GENERATE_PAYMENT_PAGE_DATA_RECEIVED: {
      draft.zuoraSignatureDetails = payload
      draft.isLoadingCheckoutPage = false
      draft.zouraPageLoader = false
      break
    }
    case Actions.GENERATE_UPDATE_PAYMENT_CARD_REQUESTED: {
      draft.zuoraSignatureDetails = initialZuoraSignatureDetails
      draft.isLoadingCheckoutPage = true
      break
    }
    case Actions.GENERATE_UPDATE_PAYMENT_CARD_RECEIVED: {
      draft.zuoraSignatureDetails = payload
      draft.isLoadingCheckoutPage = false
      break
    }
    case Actions.SIGNOUT_RECEIVED: {
      return initialState
    }
    case Actions.COUPON_FETCHED:
    case Actions.COUPON_LOADED:
    case Actions.COUPON_CAHNGED: {
      const { coupon_code } = payload
      draft.customerCoupon = coupon_code
      break
    }
    case Actions.IS_COUPON_VALID_RECEIVED: {
      const { customerCoupon, selectedPlan, data } = payload
      const coupons = draft.couponData
      coupons.push({ ...data, id: selectedPlan.id, code: customerCoupon })
      draft.selectedPlan = selectedPlan
      draft.couponData = coupons
      draft.isApplyCouponCodeLoading = false
      draft.isCouponDialogVisible = false
      break
    }
    case Actions.SIGNIN_RECEIVED: {
      draft.isLoggedOut = false
      break
    }
    case Actions.PAYMENT_ADDRESS_UPDATED: {
      draft.paymentAddressObj = payload
      break
    }
    case Actions.NAVIGATION_CHANGED: {
      draft.isFloatingTimerVisible = true

      break
    }

    case Actions.INVALD_COUPON_RECIEVED: {
      draft.invalidCouponErrorMessage = payload?.error?.message
        ? payload?.error?.message
        : payload?.body?.message
      draft.isApplyCouponCodeLoading = false

      break
    }

    case Actions.COUPON_DIALOGUE_CANCEL_BUTTON_PRESSED: {
      draft.invalidCouponErrorMessage = null
      break
    }

    case Actions.REMOVE_COUPON_CODE: {
      const { id } = payload
      const filterAppliedCoupons = draft.couponData.filter(
        coupon => coupon.id !== id
      )
      draft.checkoutErrorMessage = null
      draft.couponData = [...filterAppliedCoupons]
      draft.invalidCouponErrorMessage = null
      draft.skipCheckoutPage = false
      break
    }
    case Actions.IS_COUPON_VALID_REQUESTED: {
      const { selectedPlan } = payload
      draft.selectedPlan = selectedPlan
      draft.isApplyCouponCodeLoading = true
      break
    }
    case Actions.CHECKOUT_WALNUT_NO_MEMBER_REQUESTED:
    case Actions.CHECKOUT_SESSION_NO_MEMBER_REQUESTED:
    case Actions.CHECKOUT_SESSION_REQUESTED: {
      draft.isLoadingCheckoutPage = true
      draft.checkoutErrorMessage = null
      draft.walnutAppToken = null
      draft.walnutData = {}
      break
    }
    case Actions.CHECKOUT_SESSION_REQUESTED_FAILURE: {
      const { selectedPlan } = payload
      draft.checkoutErrorMessage = {
        id: selectedPlan?.id
      }
      break
    }
    case Actions.IS_COUPON_SKIP_CHECKOUT_ADDRESS_UPDATE_REQUESTED: {
      draft.isCouponSkipStripeAddressUpdateLoading = true
      draft.isCouponSkipStripeAddressUpdateErrorMessage = null
      break
    }
    case Actions.IS_COUPON_SKIP_CHECKOUT_ADDRESS_UPDATE_RECEIVED: {
      draft.isCouponSkipStripeAddressUpdateLoading = false
      draft.isCouponSkipStripeAddressUpdateErrorMessage = null
      break
    }
    case Actions.IS_COUPON_SKIP_STRIPE_ADDRESS_UPDATE_FAILED: {
      const { error } = payload
      draft.isCouponSkipStripeAddressUpdateLoading = false
      draft.isCouponSkipStripeAddressUpdateErrorMessage = error?.message
        ? error?.message
        : null
      break
    }
    case Actions.UNABLE_TO_PROCESS_ZOURA_PAYMENT: {
      draft.zouraProcessFailDialog = true
      break
    }
    case Actions.CLOSE_UNABLE_TO_PROCESS_ZOURA_PAYMENT: {
      draft.zouraProcessFailDialog = false
      draft.couponData = []
      break
    }
    case Actions.ENABLE_ZOURA_PAGE_LOADER: {
      draft.zouraPageLoader = true
      break
    }
    case Actions.DISABLE_ZOURA_PAGE_LOADER: {
      draft.zouraPageLoader = false
      break
    }
    case Actions.CLEAR_ZOURA_SIGNATURES: {
      draft.zuoraSignatureDetails.pageId = ''
      draft.zuoraSignatureDetails.signature = ''
      draft.zuoraSignatureDetails.token = ''
      draft.zuoraSignatureDetails.tenantId = ''
      draft.zuoraSignatureDetails.key = ''
      draft.zuoraSignatureDetails.uri = ''
      draft.zuoraSignatureDetails.price = 0
      draft.zuoraSignatureDetails.billing_period = null
      draft.zuoraSignatureDetails.no_of_billing_period = null
      break
    }
    case Actions.COUPON_DIALOG_OPEN: {
      draft.isCouponDialogVisible = true
      break
    }
    case Actions.COUPON_DIALOG_CLOSE: {
      draft.isCouponDialogVisible = false
      break
    }
    case Actions.IS_COUPON_VALID_RECEIVED_SKIP_CHECKOUT_PAGE: {
      draft.skipCheckoutPage = true
      break
    }
    case Actions.RESET_COUPON_ZUORA: {
      draft.customerCoupon = null
      draft.couponData = []
      break
    }
    case Actions.PAYMENT_METHOD_DATA_REQUESTED: {
      draft.isPaymentDetailsLoading = true
      draft.isPaymentDetailsFailed = false
      break
    }
    case Actions.BALANCE_PER_SUBSCRIPTION_RECIEVED: {
      draft.balancePerSubscription = payload?.data

      // Initialize payment configs from balance data
      if (draft.balancePerSubscription?.length > 0) {
        draft.balancePerSubscription.forEach(subscription => {
          draft.paymentConfigPerSubscriptions[subscription.subscriptionId] = {
            subscriptionName: subscription.planName,
            includeDue: true,
            includeOverdue: true,
            excluded: false
          }
        })

        // Initialize total price with all subscriptions included
        draft.totalPaymentPrice = calculateTotalPrice(
          draft.balancePerSubscription,
          draft.paymentConfigPerSubscriptions
        )
      }
      break
    }
    case Actions.PAYMENT_METHOD_DATA_RECIEVED: {
      draft.paymentDetailsData = payload?.data
      draft.isPaymentDetailsLoading = false
      draft.isPaymentDetailsFailed = false
      break
    }
    case Actions.PAYMENT_METHOD_FETCH_FAILED: {
      draft.isPaymentDetailsLoading = false
      draft.isPaymentDetailsFailed = true
      break
    }
    case Actions.PAYMENT_METHOD_CARD_UPDATE_REQUESTED: {
      draft.updatingBillingDialogLoader = true
      break
    }
    case Actions.PAYMENT_METHOD_CARD_UPDATED: {
      draft.updatingBillingDialogLoader = false
      draft.zouraPageLoader = false
      break
    }
    case Actions.SHOW_NO_SUBSCRIPTIONS_MODAL: {
      draft.shouldShowNoSubscriptionsModal = true
      break
    }
    case Actions.CLOSE_NO_SUBSCRIPTIONS_MODAL: {
      draft.shouldShowNoSubscriptionsModal = false
      break
    }
    case Actions.INVOKE_PPF_ORDER: {
      draft.isPaymentFromPPF = true
      break
    }
    case Actions.REVOKE_PPF_ORDER: {
      draft.isPaymentFromPPF = false
      break
    }
    case Actions.KEEP_PPF_USER_INFO: {
      draft.ppfUserInfo = payload
      draft.selectedPlan = payload?.selectedPlanObj
      break
    }
    case Actions.DISCARD_PPF_USER_INFO: {
      draft.ppfUserInfo = null
      break
    }
    case Actions.ENABLE_NO_SERVICE_DIALOG: {
      draft.isNoServiceDialogVisible = true
      break
    }
    case Actions.DISBALE_NO_SERVICE_DIALOG: {
      draft.isNoServiceDialogVisible = false
      break
    }
    case Actions.ENABLE_SLOT_EXPIRE_DIALOG: {
      draft.isSlotExpireDialogVisible = true
      break
    }
    case Actions.DISBALE_SLOT_EXPIRE_DIALOG: {
      draft.isSlotExpireDialogVisible = false
      break
    }
    case Actions.ENABLE_SOMETHING_WENT_WRONG_DIALOG: {
      draft.isSomethingWentWrongDialogVisible = true
      break
    }
    case Actions.DISABLE_SOMETHING_WENT_WRONG_DIALOG: {
      draft.isSomethingWentWrongDialogVisible = false
      break
    }
    case Actions.CHECKOUT_SESSION_WITHOUT_PAYMENT_RECEIVED: {
      draft.isLoadingCheckoutPage = false
      draft.shouldDisplaySuccessDialog = true
      break
    }
    case Actions.PAYMENT_SUCCESS_ALERT_ACKNOWLEDGED: {
      draft.shouldDisplaySuccessDialog = false
      break
    }
    case Actions.SKIP_LOCATION_VERIFICATION: {
      draft.isDeclareLocationDialogVisible = false
      draft.shouldSkipLocationVerification = true
      break
    }
    case Actions.LOCATION_VERIFICATION_STARTED: {
      draft.isDeclareLocationDialogVisible = true
      break
    }
    case Actions.LOCATION_VERIFICATION_CLOSED: {
      draft.isDeclareLocationDialogVisible = false
      break
    }
    case Actions.LOCATION_VERIFICATION_FILLED: {
      draft.isDeclareLocationDialogVisible = false
      draft.shouldSkipLocationVerification = false
      break
    }
    case Actions.ENABLE_FROM_PAYMENT_PLANS: {
      draft.isOnPaymentPlansPage = true
      break
    }
    case Actions.DISABLE_FROM_PLANS_PAGE: {
      draft.isOnPaymentPlansPage = false
      break
    }
    case Actions.CHANGE_PAYMENT_METHOD: {
      draft.requestedPaymentMethodChange = true
      break
    }
    case Actions.ADD_PAYMENT_METHOD: {
      draft.requestedPaymentMethodChange = true
      break
    }
    case Actions.SHOW_APPROVE_PAYMENT_POP_UP: {
      draft.isApprovePaymentPopUpVisible = true
      break
    }
    case Actions.CLOSE_APPROVE_PAYMENT_POP_UP: {
      draft.isApprovePaymentPopUpVisible = false
      break
    }
    case Actions.PAYMENT_INVOICE_REQUESTED: {
      draft.loadingInvoiceId = payload?.invoiceId
      break
    }
    case Actions.PAYMENT_INVOICE_FAILED:
    case Actions.PAYMENT_INVOICE_RECEIVED: {
      draft.loadingInvoiceId = null
      break
    }
    case Actions.UNAUTENTICATED_PAYMENT_DETAILS_REQUESTED: {
      draft.isLoadingCheckoutPage = true
      break
    }
    case Actions.UNAUTENTICATED_PAYMENT_DETAILS_RECEIVED: {
      draft.unauthenticatedPaymentDetails = payload
      draft.isLoadingCheckoutPage = false
      draft.deepLinkRedirectAfterSuccess = payload?.deepLink
      draft.isFullyPaidOrSubsidized = payload?.isFullyPaidOrSubsidized
      break
    }
    case Actions.UNAUTENTICATED_PAYMENT_DETAILS_FAILED: {
      draft.isLoadingCheckoutPage = false
      break
    }
    case Actions.UPDATE_INCLUDE_DUE_STATUS: {
      draft.includeDueInvoices = payload
      break
    }
    case Actions.UPDATE_PAYMENT_CONFIG_SUBSCRIPTION: {
      const { subscriptionId, config } = payload
      const existingConfig = draft.paymentConfigPerSubscriptions[subscriptionId]
      if (existingConfig) {
        // Just update the existing config with new values
        draft.paymentConfigPerSubscriptions[subscriptionId] = {
          ...existingConfig,
          ...config
        }
      }
      break
    }
    case Actions.UPDATE_TOTAL_PAYMENT_PRICE: {
      draft.totalPaymentPrice = payload
      break
    }
    case Actions.SELECT_ENROLLMENT_YEAR_VIEW: {
      draft.selectedEnrollmentYear = payload
      break
    }
    default: {
      // Nothing to do
      break
    }
  }
}, initialState)
